(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hound-family"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function(){
      $(function() {
                  $( "#dog_birthday , .edit_dog_birthday" ).datepicker({
                      changeMonth: true,
                      changeYear: true,
                      dateFormat: "dd/mm/yy",
                     dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
                  });
              });
     $(document).on('click','.jtpl_modal', function(e) {
  if ($(e.target).closest(".modal").length === 0 ) {
      $(this).hide();
    }
  });
     $(".popup, .popup2").on('blur',function(){
      $(this).fadeOut(300);
  });

      $('.err_msg').hide();
       // <!--   =============================================== Add pet detail ============================ -->
    $(".add_pet_profile").click(function(){
       $(".popup2").fadeIn(300,function(){$(this).focus();});
       $(".popup2").css("display","flex");
    });
     $(".cancel").click(function(){
       $(".popup2 , .popup").fadeOut();
      });


     $("#submit_pet_form").click(function(e){
       e.preventDefault();
       var customer_id  = $("#customer_id").val();
       var pet_name  = $("#pet_name").val();
       var dog_size  = $("#dog_size").val();
       var dog_birthday  = $("#dog_birthday").val();
       // alert(customer_id);
         $('#submit_pet_form').html("Saving...");
       $("#submit_pet_form"). attr("disabled", true);
       if(pet_name != "" && dog_size != "" && dog_birthday != ""){
           $('#submit_pet_form').html("Sending");
       $("#submit_pet_form"). attr("disabled", true);

        var postdata = JSON.stringify({
            customerId: customer_id,
            petName: pet_name,
            dogSize: dog_size,
            dogBirthday: dog_birthday,
          });
          $.ajax({
            type: 'POST',
            url: '/a/houndfamily/createMeta.php',
            data: {
              properties: postdata,
            },
            dataType: 'json',
            success: function(data) {
              console.log(data);
               location.reload();
            },
            error: function(data) {
               location.reload();
            }
          });
          $('.err_msg').hide();
          // location.reload();
       }else{
        $('.err_msg').show();
          $('#submit_pet_form').html("save");
       $("#submit_pet_form"). attr("disabled", false);
       }
     });
       // <!--   ===========================================End Add pet detail ============================ -->
       // <!--   =============================================== Edit pet detail ============================ -->
       $(".edit_pet_profile").click(function(){
      $(this).parents('.customer_address').find(".popup").fadeIn(300,function(){$(this).focus();});
       $(this).parents('.customer_address').find(".popup").css("display","flex");
    });
      $(".submit_edit_pet").click(function(e){
             e.preventDefault();
       var edit_customer_id  = $(this).parent().siblings(".edit_customer_id").val();
       var edit_meta_id  = $(this).parent().siblings(".edit_meta_id").val();
       var edit_pet_name  = $(this).parent().siblings(".edit_pet_name").val();
       var edit_dog_size  = $(this).parent().siblings(".edit_dog_size").val();
       var edit_dog_birthday  = $(this).parent().siblings(".edit_dog_birthday").val();
        $(this).html('sending');
       $(this). attr("disabled", true);
         if(edit_pet_name != "" && edit_dog_size != "" && edit_dog_birthday != ""){
         var postdata = JSON.stringify({
            customerId: edit_customer_id,
            metaId: edit_meta_id,
            petName: edit_pet_name,
            dogSize: edit_dog_size,
            dogBirthday: edit_dog_birthday,
          });
          $.ajax({
            type: 'POST',
            url: '/a/houndfamily/editMetafileds.php',
            data: {
              properties: postdata,
            },
            dataType: 'json',
            success: function(data) {
              console.log(data);
               location.reload();
            },
            error: function(data) {
               location.reload();
            }
          });
             $('.err_msg').hide();
    }else{
           $('.err_msg').show();
                 $(this).html('save');
        $(this). attr("disabled", false);
       }
         });

       // <!--   ======================================== End Edit pet detail ============================ -->
    $(".delete_pet_profile").click(function(){
       var delete_meta  = $(this).attr('data-value');
       var customer_id  = $(this).attr('data-customer_id');
      // alert(delete_meta);
       if(delete_meta != ""){
            $(this).html('deleting...');
        $(this). attr("disabled", true);
        var postdata = JSON.stringify({
          customerId : customer_id,
            deleteMeta: delete_meta,
          });
          $.ajax({
            type: 'POST',
            url: '/a/houndfamily/deleteMeta.php',
            async:false,
            data: {
              properties: postdata,
            },
            dataType: 'json',
            success: function(data) {
              console.log(data);
                location.reload();
            },
            error: function(data) {
               location.reload();
            }
          });
      }else{
          //$(this).html('delete');
        $(this). attr("disabled", false);
      }
     });
  });

  } catch(e) { console.error(e); }
})();
})();
